import { BaseAPI } from './BaseAPI.js'
import { WorkflowExecutionLog } from '../types/WorkflowExecutionLog.js'

export default class WorkflowExecutionLogsAPI extends BaseAPI<WorkflowExecutionLog> {
  override get resource(): string {
    return '/workflowExecutionLogs'
  }

  public replayWorkflow(traceId: string | number) {
    return this._client.post(`${this.resource}/${traceId}/replayWorkflow`)
  }

  public replayWorkflowStep(traceId: string | number, step: string) {
    return this._client.post(`${this.resource}/${traceId}/replayWorkflowStep/${step}`)
  }
}
